import * as React from 'react';
import { ArticleHeading1 } from '@cian/ui-kit/typography';

import * as styles from './styles.css';
import { IPromosCollapsedButtonProps, PromosCollapsedBlock } from '../PromosCollapsedBlock';

export interface IPromos {
  banner: React.ReactElement;
  seoLink: React.ReactElement;
  title: string;
  Button: React.ComponentType<IPromosCollapsedButtonProps>;
  onChangeOpen(opened: boolean): void;
}

export function Promos({ banner, seoLink, title, children, Button, onChangeOpen }: React.PropsWithChildren<IPromos>) {
  return (
    <div data-nav-tab="promoList/Акции" id="promoList" className={styles['nav_container']}>
      <div className={styles['title']}>
        <ArticleHeading1 as="h2">{title}</ArticleHeading1>
      </div>
      {banner}
      <div className={styles['promos-list']}>
        <PromosCollapsedBlock Button={Button} onChangeOpen={onChangeOpen} control={seoLink}>
          {children}
        </PromosCollapsedBlock>
      </div>
    </div>
  );
}
